import { createContext } from "react";


class MembersStore {
  columnVisibility = {}
  columnFilters = []
  globalFilter = undefined
  searchField = 'fullName'
  pagination = { pageIndex: 0, pageSize: 10 }
  columnPinning = { left: [] }
  // State preservation fields
  allTableData = []
  tableData = []
  selectedChip = undefined
  isLoading = true
  isRefetching = false
  open = false
  scrollTop = 0
  needsRefresh = false
}


export const membersStore = new MembersStore()
export const MembersStoreContext = createContext(membersStore)
